<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <p *ngIf="!data.usersWithBook || data.usersWithBook.length === 0">
    {{ data.message }}
  </p>

  <ng-container *ngIf="data.usersWithBook && data.usersWithBook.length > 0">
    <p>
      Los siguientes usuarios han comprado este producto.
    </p>
    <ul>
      <li *ngFor="let user of data.usersWithBook">
        {{ user.name }}
      </li>
    </ul>

    <p>¿Está seguro de que quiere eliminarlo?</p>
  </ng-container>
</div>

<div mat-dialog-actions>
  <div class="text-center">
    <button mat-button (click)="modalInteractTrue()">{{ 'confirmation.yes' | translate }}</button>
    <button mat-button [mat-dialog-close]="false">{{ 'confirmation.no' | translate }}</button>
  </div>
</div>
